define("shared/components/shared/post/secondary/publishing-method-setup/wrapper", ["exports", "@ember/component", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "later/utils/constants", "@ember/template-factory"], function (_exports, _component, _object, _service, _component2, _tracking, _constants, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _close, _autoSelectProfileIfOnlyOneWithNoPublishingMethod;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"later/utils/constants",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
  function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _classPrivateMethodGet(s, a, r) { return _assertClassBrand(a, s), r; }
  function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  {{#if this.showSelector}}
    <Shared::Post::Secondary::PublishingMethodSetup::Layout @title={{t "onboarding.side_wiz.general.title"}}>
      <:body>
        <p>{{t "onboarding.side_wiz.general.select_a_profile"}}</p>
  
        {{#each this.socialProfilesWithoutPublishingMethod as |socialProfile|}}
          <div class="cPM--secondaryCard__profile">
            <div class="o--user" style="max-width:150px">
              <span class="o--user__avatarProfile">
                <img
                  alt={{socialProfile.displayNickname}}
                  class="o--user__avatar"
                  src={{if
                    (is-present socialProfile.secureAvatarUrl)
                    socialProfile.secureAvatarUrl
                    "/assets/images/img--userAvatar--placeholder.svg"
                  }}
                />
              </span>
              <span class={{concat "o--user__avatarChild--" socialProfile.cssHandle}} data-test-id="platform-icon">
                <i class={{concat "i--" socialProfile.cssHandle "--w"}}></i>
              </span>
              <span class="o--user__title u--ellipsis"><span>{{socialProfile.displayNickname}}</span></span>
              <span class="o--user__desc u--ellipsis">{{socialProfile.accountType}}</span>
            </div>
            <Shared::Ui::Button
              @onClick={{fn this.selectSocialProfile socialProfile}}
              @text={{t "posts.modal.auto_publish.setup"}}
              @variant="mute"
            />
          </div>
        {{/each}}
  
      </:body>
    </Shared::Post::Secondary::PublishingMethodSetup::Layout>
  {{else}}
    {{component
      this.componentName
      back=this.clearSelectedProfile
      handleClose=this.handleClose
      isMultiProfilePost=@isMultiProfilePost
      post=this.post
      setPublishingSetupComponent=this.setPublishingSetupComponent
      shouldEnablePostAutoPublish=this.shouldEnablePostAutoPublish
      showInstagramAuthStatus=@showInstagramAuthStatus
      socialProfile=this.socialProfile
    }}
  {{/if}}
  */
  {
    "id": "aK7iEb9u",
    "block": "[[[41,[30,0,[\"showSelector\"]],[[[1,\"  \"],[8,[39,1],null,[[\"@title\"],[[28,[37,2],[\"onboarding.side_wiz.general.title\"],null]]],[[\"body\"],[[[[1,\"\\n      \"],[10,2],[12],[1,[28,[35,2],[\"onboarding.side_wiz.general.select_a_profile\"],null]],[13],[1,\"\\n\\n\"],[42,[28,[37,4],[[28,[37,4],[[30,0,[\"socialProfilesWithoutPublishingMethod\"]]],null]],null],null,[[[1,\"        \"],[10,0],[14,0,\"cPM--secondaryCard__profile\"],[12],[1,\"\\n          \"],[10,0],[14,0,\"o--user\"],[14,5,\"max-width:150px\"],[12],[1,\"\\n            \"],[10,1],[14,0,\"o--user__avatarProfile\"],[12],[1,\"\\n              \"],[10,\"img\"],[15,\"alt\",[30,1,[\"displayNickname\"]]],[14,0,\"o--user__avatar\"],[15,\"src\",[52,[28,[37,5],[[30,1,[\"secureAvatarUrl\"]]],null],[30,1,[\"secureAvatarUrl\"]],\"/assets/images/img--userAvatar--placeholder.svg\"]],[12],[13],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,1],[15,0,[28,[37,6],[\"o--user__avatarChild--\",[30,1,[\"cssHandle\"]]],null]],[14,\"data-test-id\",\"platform-icon\"],[12],[1,\"\\n              \"],[10,\"i\"],[15,0,[28,[37,6],[\"i--\",[30,1,[\"cssHandle\"]],\"--w\"],null]],[12],[13],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,1],[14,0,\"o--user__title u--ellipsis\"],[12],[10,1],[12],[1,[30,1,[\"displayNickname\"]]],[13],[13],[1,\"\\n            \"],[10,1],[14,0,\"o--user__desc u--ellipsis\"],[12],[1,[30,1,[\"accountType\"]]],[13],[1,\"\\n          \"],[13],[1,\"\\n          \"],[8,[39,7],null,[[\"@onClick\",\"@text\",\"@variant\"],[[28,[37,8],[[30,0,[\"selectSocialProfile\"]],[30,1]],null],[28,[37,2],[\"posts.modal.auto_publish.setup\"],null],\"mute\"]],null],[1,\"\\n        \"],[13],[1,\"\\n\"]],[1]],null],[1,\"\\n    \"]],[]]]]],[1,\"\\n\"]],[]],[[[1,\"  \"],[46,[30,0,[\"componentName\"]],null,[[\"back\",\"handleClose\",\"isMultiProfilePost\",\"post\",\"setPublishingSetupComponent\",\"shouldEnablePostAutoPublish\",\"showInstagramAuthStatus\",\"socialProfile\"],[[30,0,[\"clearSelectedProfile\"]],[30,0,[\"handleClose\"]],[30,2],[30,0,[\"post\"]],[30,0,[\"setPublishingSetupComponent\"]],[30,0,[\"shouldEnablePostAutoPublish\"]],[30,3],[30,0,[\"socialProfile\"]]]],null],[1,\"\\n\"]],[]]]],[\"socialProfile\",\"@isMultiProfilePost\",\"@showInstagramAuthStatus\"],false,[\"if\",\"shared/post/secondary/publishing-method-setup/layout\",\"t\",\"each\",\"-track-array\",\"is-present\",\"concat\",\"shared/ui/button\",\"fn\",\"component\"]]",
    "moduleName": "shared/components/shared/post/secondary/publishing-method-setup/wrapper.hbs",
    "isStrictMode": false
  });
  let WrapperComponent = _exports.default = (_class = (_close = /*#__PURE__*/new WeakSet(), _autoSelectProfileIfOnlyOneWithNoPublishingMethod = /*#__PURE__*/new WeakSet(), class WrapperComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);
      _classPrivateMethodInitSpec(this, _autoSelectProfileIfOnlyOneWithNoPublishingMethod);
      _classPrivateMethodInitSpec(this, _close);
      _initializerDefineProperty(this, "secondaryModal", _descriptor, this);
      _initializerDefineProperty(this, "selectedPost", _descriptor2, this);
      if (this.args.posts) {
        _classPrivateMethodGet(this, _autoSelectProfileIfOnlyOneWithNoPublishingMethod, _autoSelectProfileIfOnlyOneWithNoPublishingMethod2).call(this);
      }
    }
    get socialProfilesWithoutPublishingMethod() {
      return this.args.posts?.filter(post => !post.socialProfile?.hasPublishingMethod).map(post => post.socialProfile);
    }
    get componentName() {
      return this.secondaryModal.publishingMethodSetupModalComponent;
    }
    get post() {
      return this.args.posts ? this.selectedPost : this.args.post;
    }
    get socialProfile() {
      return this.args.posts ? this.selectedPost?.socialProfile : this.post?.socialProfile;
    }
    get showSelector() {
      return this.args.posts !== undefined && this.selectedPost === undefined;
    }
    get shouldEnablePostAutoPublish() {
      if (!this.socialProfile) {
        return false;
      }
      return !this.post?.autoPublish && !this.socialProfile.get('hasDevices');
    }
    selectSocialProfile(socialProfile) {
      this.selectedPost = this.args.posts?.find(post => post.socialProfile === socialProfile)?.post;
    }
    clearSelectedProfile() {
      this.selectedPost = undefined;
    }
    setPublishingSetupComponent(component) {
      this.secondaryModal.setPublishingMethodSetupModalComponent(component);
    }
    handleClose() {
      if (this.args.posts ? this.args.posts.every(post => post.socialProfile.hasPublishingMethod) : this.args.socialProfile?.hasPublishingMethod) {
        _classPrivateMethodGet(this, _close, _close2).call(this);
      } else {
        this.setPublishingSetupComponent(_constants.NO_PUBLISHING_METHOD_COMPONENTS.INDEX);
        this.selectedPost = undefined;
      }
    }
  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "secondaryModal", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "selectedPost", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "selectSocialProfile", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "selectSocialProfile"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clearSelectedProfile", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "clearSelectedProfile"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setPublishingSetupComponent", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "setPublishingSetupComponent"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleClose", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleClose"), _class.prototype)), _class);
  function _close2() {
    this.secondaryModal.removeModal();
  }
  function _autoSelectProfileIfOnlyOneWithNoPublishingMethod2() {
    if (this.socialProfilesWithoutPublishingMethod?.length === 1) {
      this.selectedPost = this.args.posts?.find(post => post.socialProfile === this.socialProfilesWithoutPublishingMethod?.[0])?.post;
    }
  }
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, WrapperComponent);
});